/**
 * Build list API query values: comma-separated enums (canonical casing) and positive integer IDs.
 * Invalid enum tokens are dropped; invalid IDs are omitted.
 */

export function commaSeparatedEnums(
  input: string | string[] | undefined | null,
  allowed: readonly string[],
): string | undefined {
  if (input == null || input === "") return undefined;
  const allowedUpper = new Map(
    allowed.map((a) => [a.toUpperCase(), a] as const),
  );
  const parts = (Array.isArray(input) ? input : String(input).split(","))
    .map((s) => s.trim())
    .filter(Boolean);
  const out: string[] = [];
  for (const p of parts) {
    const canon = allowedUpper.get(p.toUpperCase());
    if (canon && !out.includes(canon)) out.push(canon);
  }
  return out.length ? out.join(",") : undefined;
}

export function positiveInt(
  value: number | string | undefined | null,
): number | undefined {
  if (value == null || value === "") return undefined;
  const n = typeof value === "number" ? value : Number(String(value).trim());
  if (!Number.isFinite(n) || n < 1 || !Number.isInteger(n)) return undefined;
  return n;
}

/** Trim; return `undefined` if empty (for optional text query params). */
export function parseOptionalTrimmedString(
  value: string | undefined | null,
): string | undefined {
  const t = value == null ? "" : String(value).trim();
  return t ? t : undefined;
}

/** Serialize a definite boolean for APIs that accept `true` / `false` in the query string. */
export function booleanQueryParam(
  value: boolean | undefined,
): string | undefined {
  if (value === undefined) return undefined;
  return value ? "true" : "false";
}
